import useUpdateAppData from './useUpdateAppData'

export default useUpdateAppData
